'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ga = require('./ga');

var _ga2 = _interopRequireDefault(_ga);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ga2.default;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/GA/index.js
// module id = 826
// module chunks = 1